import axios from './axios';

export default {
  list() {
    return axios.get('/events');
  },
  markEventAsSeen(eventId) {
    return axios.patch(`/events/${eventId}/mark_as_seen`);
  },
};
